import React from 'react'
import Button from './Button'

const ButtonIconTrash = (props) => {
  return (
    <Button
      icon="trash"
      {...props}
    />
  )
}

export default ButtonIconTrash
